import { render, staticRenderFns } from "./ResetVerification.vue?vue&type=template&id=5f8c6102&scoped=true"
import script from "./ResetVerification.vue?vue&type=script&lang=js"
export * from "./ResetVerification.vue?vue&type=script&lang=js"
import style0 from "./ResetVerification.vue?vue&type=style&index=0&id=5f8c6102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c6102",
  null
  
)

export default component.exports